module.exports = __webpack_public_path__ + "static/media/0283_Small.5ca6fcb6.jpg";